import appConfig from '../../appConfig.js'
import { asyncAjax } from 'services/ajax'
import config from '../../appConfig'
import { publishEvent } from 'services/events'

export const GET_OPTINS = 'GET_OPTINS';
export const GET_OPTINS_COMPLETED = 'GET_OPTINS_COMPLETED';
export const GET_OPTINS_FAILED = 'GET_OPTINS_FAILED';

export function getOptIns(userId) {
  return async dispatch => {
    try {
      dispatch({type: GET_OPTINS, payload: {userId}});
      const xhr = await asyncAjax(appConfig.apiUrl + 'optIns?userId=' + userId);
      const res = xhr.responseText;
      if (xhr.status !== 200) {
        dispatch({type: GET_OPTINS_FAILED, payload: {message: 'Request failed with status code: ' + xhr.status}});
      } else {
        dispatch({type: GET_OPTINS_COMPLETED, payload: JSON.parse(res)});
      }
    } catch (err) {
      dispatch({type: GET_OPTINS_FAILED, payload: err});
    }
  }
}

export const SET_OPTINS = 'SET_OPTINS';
export const SET_OPTINS_COMPLETED = 'SET_OPTINS_COMPLETED';
export const SET_OPTINS_FAILED = 'SET_OPTINS_FAILED';

export function setOptIns(userId, optIns) {
  return async dispatch => {
    try {
      dispatch({type: SET_OPTINS, payload: {userId}});
      const xhr = await asyncAjax(appConfig.apiUrl + 'optIns', JSON.stringify({userId, ...optIns}));
      const res = xhr.responseText;
      if (xhr.status !== 200) {
        dispatch({type: SET_OPTINS_FAILED, payload: {message: 'Request failed with status code: ' + xhr.status}});
      } else {
        dispatch({type: SET_OPTINS_COMPLETED, payload: JSON.parse(res)});
      }
    } catch (err) {
      dispatch({type: SET_OPTINS_FAILED, payload: err});
    }
  }
}

export const UNSUBSCRIBE = 'UNSUBSCRIBE';
export const UNSUBSCRIBE_COMPLETED = 'UNSUBSCRIBE_COMPLETED';
export const UNSUBSCRIBE_FAILED = 'UNSUBSCRIBE_FAILED';

export function unsubscribe(userId, listId) {
  return async dispatch => {
    dispatch({type: UNSUBSCRIBE, payload: {userId, listId}});
    let response;
    try {
      const xhr = await asyncAjax(`${config.apiUrl}unsubscribe`, JSON.stringify({ userId, listId }));
      const res = xhr.responseText;
      if (xhr.status !== 200) {
        console.log("Unsubscribe failed, status =", xhr.status, " responseText =", res);
        dispatch({ type: UNSUBSCRIBE_FAILED, payload: { message: "Server returned an error." } });
        return;
      }
      response = JSON.parse(res);
      dispatch({ type: UNSUBSCRIBE_COMPLETED, payload: response });
    } catch (err) {
      dispatch({type: UNSUBSCRIBE_FAILED, payload: err});
      return;
    }
    if (!response || !response.unsubscribed || response.unsubscribed !== "OK") {
      return;
    }
    const payload = {
      userId,
      email: response.email,
      listId,
      consent: "implicit",
      location: "link"
    };
    publishEvent('Unsubscribed', payload);
  }
}

export const SUBSCRIBE = 'SUBSCRIBE';
export const SUBSCRIBE_COMPLETED = 'SUBSCRIBE_COMPLETED';
export const SUBSCRIBE_FAILED = 'SUBSCRIBE_FAILED';

export function subscribe(userId, listId) {
  return async dispatch => {
    dispatch({type: SUBSCRIBE, payload: {userId, listId}});
    let response;
    try {
      const xhr = await asyncAjax(`${config.apiUrl}subscribe`, JSON.stringify({ userId, listId }));
      const res = xhr.responseText;
      if (xhr.status !== 200) {
        console.log("Subscribe failed, status =", xhr.status, " responseText =", res);
        dispatch({ type: SUBSCRIBE_FAILED, payload: { message: "Server returned an error." } });
        return;
      }
      response = JSON.parse(res);
      dispatch({ type: SUBSCRIBE_COMPLETED, payload: response });
    } catch (err) {
      dispatch({type: SUBSCRIBE_FAILED, payload: err});
      return;
    }
    if (!response || !response.subscribed || response.subscribed !== "OK") {
      return;
    }
    const payload = {
      userId,
      email: response.email,
      listId,
      consent: "implicit",
      location: "link"
    };
    publishEvent('Subscribed', payload);
  }
}



// WEBPACK FOOTER //
// ./src/actions/unsubscribeActions.js